import { MutableRefObject, useCallback, useEffect } from 'react';
import { MouseEventHandler } from '../types';

/**
 * Simple hook to listen for click events NOT activated by referenced component
 *
 * @param  {MutableRefObject<any>} ref
 * @param  {MouseEventHandler} func
 */
const useClickAway = (ref: MutableRefObject<any>, func: MouseEventHandler): void => {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target)) func(e as any); // deal with synthetic vs. native event
    },
    [ref, func]
  );

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
};

export default useClickAway;
